const extractAndFormat = (input) => {
  if (!input) {
    return
  }

  const currency = input.match(/[^\d.,]/)[0];
  const numericString = input.replace(currency, '').replace(/,/g, '');
  const price = parseFloat(numericString);

  if (Math.floor(price) === price) {
    return `${currency}${Math.floor(price)}`;
  }
  return `${currency}${price.toFixed(2)}`;
};

export default extractAndFormat;
